import { Model } from "@bryntum/schedulerpro";
import { HasProjectMixin } from "./mixins/HasProjectMixin";

export class BoardContextStatement extends HasProjectMixin(Model) {
  declare id: number;
  declare group: number;
  declare headline: string | null;
  declare body: string;
  declare order: number;
  declare isPreview: boolean;

  static get $name() {
    return "BoardContextStatement";
  }

  static get fields() {
    return [
      "id",
      { name: "group", type: "number" },
      { name: "headline", defaultValue: null },
      "body",
      { name: "order", type: "number", defaultValue: 0 },
      { name: "isPreview", dataSource: "is_preview", type: "boolean", defaultValue: false },
    ];
  }
}

// @ts-expect-error - exposeProperties is internal method
BoardContextStatement.exposeProperties();
